import styled from "styled-components";
import Col from "react-bootstrap/Col";

export const StyledTitles = styled.h3`
margin-bottom: 25px;
font-size: 23px;
line-height: 33px;
font-weight: bold

`

export const StyledText = styled.p`
margin-bottom: 50px;
a {
  color: #E63457
}

`

export const StyledMedio = styled(Col)`
margin-bottom: 50px;
a {
  color: #E63457
}

ul li {
  margin-bottom: 10px;
}

`